// extracted by mini-css-extract-plugin
export default {"content":"style_content__wKcdI","animated":"style_animated__gINzp"};